import { CarbonEmissionsOrganizationResponse } from "Api/carbonEmissions/carbonEmissions.types";

// Define only the data we actually need to store
export type CleanedProject = {
  project_id: string;
  project_title?: string;
  values: Array<{
    start_time: string;
    value: number;
  }>;
};

export type CleanedCarbonEmissionsData = {
  projects: CleanedProject[];
};

export type NormalizedCarbonEmissionsData = {
  organizationId: string;
  data: CleanedCarbonEmissionsData;
};

// Normalization: Filter out unnecessary data but keep all potentially useful fields
export const normalizeCarbonEmissionsData = (
  apiResponse: CarbonEmissionsOrganizationResponse,
  organizationId: string
): NormalizedCarbonEmissionsData => {
  // Filter and clean the API response - remove fields we definitely don't need
  const cleanedProjects: CleanedProject[] = (apiResponse.projects || []).map(
    project => ({
      project_id: project.project_id,
      project_title: project.project_title,
      // Only keep values that have the fields we need
      values: (project.values || [])
        .filter(value => value.start_time && typeof value.value === "number")
        .map(value => ({
          start_time: value.start_time,
          value: value.value
        }))
    })
  );

  return {
    organizationId,
    data: {
      projects: cleanedProjects
    }
  };
};
